export default "__VITE_ASSET__4acee432__"